var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('kdProblemIndex',{attrs:{"problemData":_vm.problemData,"view-only":_vm.isViewOnly},on:{"update:problemData":function($event){_vm.problemData=$event},"update:problem-data":function($event){_vm.problemData=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }